import styled from 'styled-components';
import { device } from '../../../../lib/media-query';
import { uiTypes } from '../../../../lib';

export const StyledSpotHeader = styled.p<{ headerSize: uiTypes.SpotHeaderSize; avenirFont?: boolean }>`
    color: #0b0b0b;
    font-family: ${({ theme, avenirFont }) => (avenirFont ? theme.fontFamily.secondary : theme.fontFamily.primary)};
    font-size: ${({ headerSize }) => headerSize.mobile};
    font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
    letter-spacing: 0;
    line-height: 1.13;
    white-space: pre-line;

    @media ${device.tablet} {
        font-size: ${({ headerSize }) => headerSize.desktop};
        line-height: 1.2em;
    }
`;
